import FieldBuilder from "../../form-components/field-builder";

interface Props {
  required?: boolean;
}

const PasswordInput: React.FC<Props> = (props) => {

  const { required = true } = props;

  return (
    <FieldBuilder
      rules={{ minLength: 8, required: required }}
      name="password"
      formItemLabelStyle={{ color: "gray" }}
      label="password"
      input={{ type: "password" }}
    />
  );
};

export default PasswordInput;
